export default "__VITE_ASSET__643e5392__"